import React from 'react'
import SupplyBillAgreeIco from '../../../../view/items/SupplyBillAgreeIco'
import { useState } from 'react';
import MyModal from '../../../../../../UI/modal/MyModal';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PaymentChangeStatusForm from './PaymentChangeStatusForm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IcoButtonStatus from '../../../../../../UI/form/icoButtons/IcoButtonStatus';
import { statusPaymentText } from '../../../../../../../helpers/status/StatusSupplyOrderHelper';

const PaymentChangeStatusButton = ({ billPayment }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <IcoButtonStatus 
            // classNameMain={}
            ico={<CheckCircleIcon />}
            text={'Cтатус оплати'}
            textStatus={statusPaymentText[billPayment.status]}
            status={billPayment.status}
            onClick={e => setOpen(true)}
        />
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Cтатус оплати'}
            textOk={'Сплачено'}
            ico={<CheckCircleIcon />}
            value={
                billPayment.status && billPayment.status === 'pay' ? true : billPayment.status
            }
        /> */}

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <PaymentChangeStatusForm
                    // supplyOrderId={supplyOrderId}
                    billPaymentBd={billPayment}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default PaymentChangeStatusButton